import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ReCaptchaV3Store } from '../store/reCaptchaV3Store'

export const ReCaptchaV3Context = createContext<ReCaptchaV3Store | null>(null)

export const useReCaptchaV3Context = () => {
  const context = useContext(ReCaptchaV3Context)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReCaptchaV3Context')

  return context
}

type IProviderReCaptchaV3Props = {
  value: ReCaptchaV3Store
  children: ReactNode
}

export const ProviderReCaptchaV3: FC<IProviderReCaptchaV3Props> = ({ value, children }) => {
  return <ReCaptchaV3Context.Provider value={value}>{children}</ReCaptchaV3Context.Provider>
}
